import { takeLatest, call, put } from 'redux-saga/effects'
import axios from 'axios'
import { CLEAR_HELP_TEXT, FETCH_HELP_TEXT, SET_HELP_TEXT} from '../actionTypes'

// fetch help text by the lookup key.
function fetchHelpText(key) {
  return axios({
    method: "get",
    url: `/api/help_text/${key}`,
  })
}



function* workerFetchHelpText(action) {
  try {
    yield put({type: CLEAR_HELP_TEXT})

    const response = yield call(fetchHelpText, action.key)
    if (response?.data) {
      yield put({type: SET_HELP_TEXT, helpText: response.data})
    }

  } catch (ex) {
    console.log(ex)
  }
}

export function* watchFetchHelpTextSaga() {
    yield takeLatest(FETCH_HELP_TEXT, workerFetchHelpText)
}


